import { updateRoofDetails } from "../../../../Features/quantityInfo";
import { panelInformation } from "../../../DataFiles/panelInformation";
import { generationLosses } from "../../Functions/generationCalculate";
import {
  canPlaceImage,
  canPlaceImageInside,
  isImageInsideObstacle,
  isImageInsideObstacleRotation,
  isPositionFree,
} from "../canvasFunction";
import { getPixelsPerMeter } from "./smithStructure";

export const handleImageDimension = ({
  roofInfo,
  roofDetail,
  designParameter,
}) => {
  let pixelMultiple = getPixelsPerMeter(roofInfo);

  const panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  const panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );

  // find Limit Capacity
  let limitCapacity = 0;
  const structureWatt = panel.pMax;
  if (roofDetail.customCapacity !== 0 && designParameter.customCapacityCheck) {
    limitCapacity = (
      roofDetail.customCapacity /
      (roofDetail.blockRow * roofDetail.blockCol * (structureWatt / 1000))
    ).toFixed();
  }
  // Find the image Dimension
  let width = panel.width;
  let height = panel.height;
  let tiltAngle = roofDetail.tiltAngle;

  if (roofDetail.roofType === "Shed Roof") {
    tiltAngle = 0;
  }
  if (roofDetail.orientation === "Landscape") {
    width = panel.height;
    height = panel.width;
  }
  const angle = (tiltAngle * Math.PI) / 180;
  let hyp =
    height * roofDetail.blockRow +
    (roofDetail.blockRow - 1) * (roofDetail.moduleSpacing / 1000);

  if (roofDetail.roofType !== "Shed Roof") {
    hyp += 0.301;
  }
  const base = hyp * Math.cos(angle);
  let perp = hyp * Math.sin(angle) * 1.5 + roofDetail.frontHeight / 1000;
  if (roofDetail.roofType === "Shed Roof") {
    perp = roofDetail.frameSpacing / 1000;
  }
  const imgDimension = {
    height: base * pixelMultiple,
    width: width * roofDetail.blockCol * pixelMultiple,
    gap: perp * pixelMultiple,
    rowDistance: Number(perp.toFixed(5)),
    orientation: roofDetail.orientation,
    rowFrame: roofDetail.blockRow,
    colFrame: roofDetail.blockCol,
    moduleSpacing: (roofDetail.moduleSpacing / 1000) * pixelMultiple,
    frameSpacing: (roofDetail.frameSpacing / 1000) * pixelMultiple,
    walkWaySpacing: roofDetail.roadSpace * pixelMultiple,
    limitCapacity: limitCapacity,
    pixelMultiple: pixelMultiple,
  };
  return imgDimension;
};

export const handleCustomizePlacement = ({
  roofInfo,
  dispatch,
  abstacles,
  roofDetail,
  quantityInfo,
  designParameter,
}) => {
  if (roofDetail.roofType === "Select") {
    alert("First of all select any roof type.");
    return false;
  }
  const roofPolygons = roofInfo?.value?.polygonCoordinates
    ? roofInfo.value.polygonCoordinates
    : [];
  const mapOption = roofInfo.value.mapOption;
  const zoom = mapOption.zoom;
  let pixelMultiple = 0;
  if (mapOption.mapTypeId === "gridView") {
    pixelMultiple = roofInfo.value.pixelValue * 3.28084;
  } else {
    if (zoom < 20) {
      pixelMultiple = 7.74 / (2 * (20 - zoom));
    } else if (zoom > 20) {
      pixelMultiple = 7.74 * 2 * (zoom - 20);
    } else {
      pixelMultiple = 7.74;
    }
  }

  const imgDimension = handleImageDimension({
    roofInfo,
    roofDetail,
    designParameter,
  });

  const newImages = [];
  const polygonCoordinates = roofPolygons[quantityInfo.roofNo].updatedPoints;
  const adjustedPoints = polygonCoordinates.flatMap((point) => [
    point.x + 0,
    point.y + 0,
  ]);
  const minX = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 0));
  const minY = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 1));
  const maxX = Math.max(...adjustedPoints.filter((_, i) => i % 2 === 0));
  const maxY = Math.max(...adjustedPoints.filter((_, i) => i % 2 === 1));

  if (roofDetail.customCapacityType === "Custom") {
    imgDimension.gap = (roofDetail.rowDistance / 1000) * pixelMultiple;
  }

  const angleDegrees = 0;
  let x = minX;
  let y = minY + pixelMultiple * 0.305;
  let col = 0;
  let row = 0;
  let isFirstRowPlaced = false;
  let updateCondition = true;
  while (y <= maxY) {
    while (x <= maxX) {
      if (
        imgDimension.limitCapacity !== 0 &&
        newImages.length >= imgDimension.limitCapacity
      ) {
        updateCondition = false;
      }
      if (
        updateCondition &&
        canPlaceImage(
          x,
          y,
          imgDimension.width,
          imgDimension.height,
          polygonCoordinates,
          angleDegrees
        ) &&
        isPositionFree(
          x,
          y,
          imgDimension.width,
          imgDimension.height,
          newImages
        ) &&
        isImageInsideObstacle(
          x,
          y,
          imgDimension.width,
          imgDimension.height,
          abstacles
        )
      ) {
        col++;
        if (col === 1) {
          x += pixelMultiple * 0.305;
          isFirstRowPlaced = true;
          row++;
          if (row === 1) {
            y += pixelMultiple * 0.305;
          }
        }
        const imageId = Number(Math.floor(x * y));
        const newImage = {
          id: imageId,
          x: x,
          y: y,
          angleDegree: 0,
          width: imgDimension.width,
          height: imgDimension.height,
          gap: imgDimension.gap,
          rowFrame: imgDimension.rowFrame,
          colFrame: imgDimension.colFrame,
          moduleSpacing: imgDimension.moduleSpacing,
        };
        newImages.push(newImage);
        if (
          col % roofDetail.walkWayCol === 0 &&
          roofDetail.walkWayCol !== 0 &&
          roofDetail.walkWayType === "With"
        ) {
          x += imgDimension.width + imgDimension.walkWaySpacing;
        } else {
          x += imgDimension.width + imgDimension.frameSpacing;
        }
      } else {
        x += 1;
      }
    }
    col = 0;
    x = minX;
    if (row === 0 && !isFirstRowPlaced) {
      y += 1;
    } else {
      y += imgDimension.height + imgDimension.gap;
    }
  }
  calculatedCustomStructure({
    newImages,
    dispatch,
    roofDetail,
    quantityInfo,
    imgDimension,
    roofInfo,
  });
};

export const calculatedCustomStructure = ({
  newImages,
  dispatch,
  roofDetail,
  quantityInfo,
  imgDimension,
  roofInfo,
}) => {
  let panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  let panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );

  let totalStructure = newImages.length;
  // Need to update
  let noOfPvModule = Object.values(newImages).reduce(
    (sum, value) => sum + value.rowFrame * value.colFrame,
    0
  );
  const totalKilowatt = (noOfPvModule * (panel.pMax / 1000)).toFixed(1);

  const rowDistance =
    roofDetail.customCapacityType === "Auto"
      ? Number((imgDimension.rowDistance * 1000).toFixed(2))
      : roofDetail.rowDistance;


  const myObject = {
    images: newImages,
    structureType: "Single",
    totalKilowatt: totalKilowatt,
    totalStructure: totalStructure,
    customCapacity: totalKilowatt,
    pvModule: noOfPvModule,
    mountingStructure: "Customized Structure",
    rowDistance: rowDistance,
    azimuth: 180,
    multipleStructure: [],
  };
  dispatch(
    updateRoofDetails({
      index: quantityInfo.roofNo,
      fields: myObject,
    })
  );

  const value = { ...roofDetail, ...myObject };
  generationLosses(value, quantityInfo, dispatch);
};

export const handleCustomizedPanelRotation = ({
  dispatch,
  abstacles,
  roofInfo,
  gridInfo,
  designParameter,
  quantityInfo,
  value,
  changeAzimuth,
}) => {
  const roofData = quantityInfo.roofData;
  const index = quantityInfo.roofNo;
  const roofDetail = roofData.length > 0 ? roofData[index] : [];

  if (roofDetail.roofType === "Select") {
    alert("First of all select any roof type.");
    return false;
  }

  let limitCapacity = 0;
  let updateCondition = true;
  let panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  let panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );
  const structureWatt = panel.pMax;
  if (roofDetail.customCapacity !== 0 && designParameter.customCapacityCheck) {
    limitCapacity = (
      roofDetail.customCapacity /
      (roofDetail.blockRow * roofDetail.blockCol * (structureWatt / 1000))
    ).toFixed();
  }

  let azimuth = roofDetail.azimuth;
  if (value === "up") {
    azimuth++;
  } else if (value === "down") {
    azimuth--;
  } else if (changeAzimuth) {
    azimuth = changeAzimuth;
  }

  let angleDegrees;
  if (azimuth >= 180) {
    angleDegrees = azimuth - 180;
  } else {
    angleDegrees = azimuth + 180;
  }

  /////////////////////////////////////////
  // let row = 0;
  // let col = roofDetail.walkWayCol;
  let row = roofDetail.blockRow;
  let col = roofDetail.blockCol;
  if (roofDetail.walkWayType === "With") {
    row = 0;
    col = roofDetail.walkWayCol;
  }
  // if (roofDetail.roofType === "Shed Roof") {
  //   row = roofDetail.blockRow;
  //   col = roofDetail.blockCol;
  // }
  // The isssue is come due to above lines work on it

  const colVal = col === 0 ? 10 : col;
  let factor = 500 + (500 % colVal);
  let walkway =
    gridInfo.unit === "m" ? roofDetail.walkWay : roofDetail.walkWay * 0.3048;
  let space = walkway * 20;
  // let space = 0
  /////////////////////////////////////////
  let currCol = 0;
  let currRow = 0;
  if (angleDegrees === 90 || angleDegrees === 270) angleDegrees += 0.5;
  if (
    angleDegrees <= 0 ||
    angleDegrees === 90 ||
    angleDegrees === 270 ||
    angleDegrees >= 360
  ) {
    return;
  }
  const roofPolygons = roofInfo?.value?.polygonCoordinates
    ? roofInfo.value.polygonCoordinates
    : [];
  const imgDimension = handleImageDimension({
    roofInfo,
    roofDetail,
    designParameter,
  });
  ////////////////////////////////////
  walkway = roofDetail.walkWayType === "With" ? imgDimension.walkWaySpacing : 0;
  // space = imgDimension.gap;
  if (roofDetail.customCapacityType === "Custom") {
    space = (roofDetail.rowDistance / 1000) * imgDimension.pixelMultiple;
  } else {
    space = imgDimension.gap;
  }
  let proP = [];
  let pInd = 0;
  ////////////////////////////////////

  let newImages = [];
  const polygonCoordinates = roofPolygons[index].updatedPoints;
  const adjustedPoints = polygonCoordinates.flatMap((point) => [
    point.x,
    point.y,
  ]);
  let maxX = Math.max(...adjustedPoints.filter((_, i) => i % 2 === 0));
  let maxY = Math.max(...adjustedPoints.filter((_, i) => i % 2 === 1));
  let minX = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 0));
  let minY = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 1));

  let angle = angleDegrees * (Math.PI / 180);

  const width = imgDimension.width + imgDimension.frameSpacing;

  if (
    (angleDegrees < 90 && angleDegrees > 0) ||
    (angleDegrees > 180 && angleDegrees < 270)
  ) {
    let x = maxX;

    let testY = minY + imgDimension.height * 0.3;

    let offVal = 0;
    // let offVal = maxY + maxX;
    while (x > minX - offVal) {
      let currX = x + designParameter.xValue;
      let currY = testY + designParameter.yValue;
      proP[pInd] = [];
      while (currX >= minX - offVal && currX <= maxX && currY <= maxY) {
        if (limitCapacity !== 0 && newImages.length >= limitCapacity) {
          updateCondition = false;
        }
        if (
          updateCondition &&
          canPlaceImageInside(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            polygonCoordinates
          ) &&
          isImageInsideObstacleRotation(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            abstacles
          )
        ) {
          newImages.push({
            id: newImages.length,
            x: currX,
            y: currY,
            width: imgDimension.width,
            height: imgDimension.height,
            type: "Customized Structure",
            gap: imgDimension.gap,
            angleDegree: angleDegrees,
            rowFrame: imgDimension.rowFrame,
            colFrame: imgDimension.colFrame,
            moduleSpacing: imgDimension.moduleSpacing,
          });
          proP[pInd].push({ currX, currY });
        }
        currCol++;
        if (currCol === col) {
          currX += Math.abs((width + walkway) * Math.cos(angle));
          currY += Math.abs((width + walkway) * Math.sin(angle));
          currCol = 0;
        } else {
          currX += Math.abs(width * Math.cos(angle));
          currY += Math.abs(width * Math.sin(angle));
        }
      }
      // If the current proP[pInd] is not empty then increment
      if (proP[pInd].length > 0) pInd++;
      currCol = 0;
      currRow++;
      if (currRow % row === 0 && currRow !== 0) {
        x =
          x -
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.cos(angle)
          ) -
          Math.abs((imgDimension.height + walkway + space) * Math.sin(angle));
        testY =
          testY -
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.sin(angle)
          ) +
          Math.abs((imgDimension.height + walkway + space) * Math.cos(angle));
      } else {
        x =
          x -
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.cos(angle)
          ) -
          Math.abs((imgDimension.height + space) * Math.sin(angle));
        testY =
          testY -
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.sin(angle)
          ) +
          Math.abs((imgDimension.height + space) * Math.cos(angle));
      }
      // x-=50;
      // y-=500;
    }
    let y = testY;
    while (y < maxY) {
      let currX = x + designParameter.xValue;
      let currY = y + designParameter.yValue;

      currCol = 0;
      proP[pInd] = [];
      while (currX <= maxX && currY <= maxY) {
        if (limitCapacity !== 0 && newImages.length >= limitCapacity) {
          updateCondition = false;
        }
        if (
          updateCondition &&
          canPlaceImageInside(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            polygonCoordinates
          ) &&
          isImageInsideObstacleRotation(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            abstacles
          )
        ) {
          newImages.push({
            id: newImages.length,
            x: currX,
            y: currY,
            width: imgDimension.width,
            height: imgDimension.height,
            type: "Customized Structure",
            gap: imgDimension.gap,
            angleDegree: angleDegrees,
            rowFrame: imgDimension.rowFrame,
            colFrame: imgDimension.colFrame,
            moduleSpacing: imgDimension.moduleSpacing,
          });
          proP[pInd].push({ currX, currY });
        }
        currCol++;
        if (currCol === col) {
          currX += Math.abs((width + walkway) * Math.cos(angle));
          currY += Math.abs((width + walkway) * Math.sin(angle));
          currCol = 0;
        } else {
          currX += Math.abs(width * Math.cos(angle));
          currY += Math.abs(width * Math.sin(angle));
        }
        // currX += Math.abs(imgDimension.width * Math.cos(angle));
        // currY += Math.abs(imgDimension.width * Math.sin(angle));
      }

      if (proP[pInd].length > 0) pInd++;
      currRow++;
      if (currRow % row === 0 && currRow !== 0) {
        x =
          x +
          0 * Math.abs(1 * imgDimension.width * Math.cos(angle)) -
          Math.abs((imgDimension.height + walkway + space) * Math.sin(angle));
        y =
          y +
          0 * Math.abs(1 * imgDimension.width * Math.sin(angle)) +
          Math.abs((imgDimension.height + walkway + space) * Math.cos(angle));
      } else {
        x =
          x +
          0 * Math.abs(1 * imgDimension.width * Math.cos(angle)) -
          Math.abs((imgDimension.height + space) * Math.sin(angle));
        y =
          y +
          0 * Math.abs(1 * imgDimension.width * Math.sin(angle)) +
          Math.abs((imgDimension.height + space) * Math.cos(angle));
      }
    }
  } else {
    let x = minX;
    let testY = minY + imgDimension.height * 0.3;

    let offVal = 0;
    while (x < maxX + offVal) {
      proP[pInd] = [];
      newImages = [...newImages];
      let currX = x + designParameter.xValue;
      let currY = testY + designParameter.yValue;

      currCol = 0;
      while (currX < maxX + offVal && currX >= minX && currY <= maxY) {
        if (limitCapacity !== 0 && newImages.length >= limitCapacity) {
          updateCondition = false;
        }
        if (
          updateCondition &&
          canPlaceImageInside(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            polygonCoordinates
          ) &&
          isImageInsideObstacleRotation(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            abstacles
          )
        ) {
          newImages.push({
            id: newImages.length,
            x: currX,
            y: currY,
            width: imgDimension.width,
            height: imgDimension.height,
            type: "Customized Structure",
            gap: imgDimension.gap,
            angleDegree: angleDegrees,
            rowFrame: imgDimension.rowFrame,
            colFrame: imgDimension.colFrame,
            moduleSpacing: imgDimension.moduleSpacing,
          });
          proP[pInd].push({ currX, currY });
        }

        currCol++;
        if (currCol === col) {
          currX -= Math.abs((width + walkway) * Math.cos(angle));
          currY += Math.abs((width + walkway) * Math.sin(angle));
          currCol = 0;
        } else {
          currX -= Math.abs(width * Math.cos(angle));
          currY += Math.abs(width * Math.sin(angle));
        }
      }

      // If the current proP[pInd] is not empty then increment
      if (proP[pInd].length > 0) pInd++;

      currRow++;
      if (currRow % row === 0 && currRow !== 0) {
        x =
          x +
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.cos(angle)
          ) +
          Math.abs((imgDimension.height + walkway + space) * Math.sin(angle));
        testY =
          testY -
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.sin(angle)
          ) +
          Math.abs((imgDimension.height + walkway + space) * Math.cos(angle));
      } else {
        x =
          x +
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.cos(angle)
          ) +
          Math.abs((imgDimension.height + space) * Math.sin(angle));
        testY =
          testY -
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.sin(angle)
          ) +
          Math.abs((imgDimension.height + space) * Math.cos(angle));
      }
    }
    let y = testY;
    while (y < maxY) {
      proP[pInd] = [];
      newImages = [...newImages];
      let currX = x + designParameter.xValue;
      let currY = y + designParameter.yValue;
      currCol = 0;
      while (currX >= minX && currY <= maxY) {
        if (limitCapacity !== 0 && newImages.length >= limitCapacity) {
          updateCondition = false;
        }
        if (
          updateCondition &&
          canPlaceImageInside(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            polygonCoordinates
          ) &&
          isImageInsideObstacleRotation(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            abstacles
          )
        ) {
          newImages = [...newImages];
          newImages.push({
            id: newImages.length,
            x: currX,
            y: currY,
            width: imgDimension.width,
            height: imgDimension.height,
            type: "Customized Structure",
            gap: imgDimension.gap,
            angleDegree: angleDegrees,
            rowFrame: imgDimension.rowFrame,
            colFrame: imgDimension.colFrame,
            moduleSpacing: imgDimension.moduleSpacing,
          });
          proP[pInd].push({ currX, currY });
        }
        currCol++;
        if (currCol === col) {
          currX -= Math.abs((width + walkway) * Math.cos(angle));
          currY += Math.abs((width + walkway) * Math.sin(angle));
          currCol = 0;
        } else {
          currX -= Math.abs(width * Math.cos(angle));
          currY += Math.abs(width * Math.sin(angle));
        }
      }

      if (proP[pInd].length > 0) pInd++;
      currRow++;
      if (currRow % row === 0 && currRow !== 0) {
        x =
          x +
          0 * imgDimension.width * Math.cos(angle) +
          Math.abs((imgDimension.height + walkway + space) * Math.sin(angle));
        y =
          y +
          0 * Math.abs(imgDimension.width * Math.sin(angle)) +
          Math.abs((imgDimension.height + walkway + space) * Math.cos(angle));
      } else {
        x =
          x +
          0 * imgDimension.width * Math.cos(angle) +
          Math.abs((imgDimension.height + space) * Math.sin(angle));
        y =
          y +
          0 * Math.abs(imgDimension.width * Math.sin(angle)) +
          Math.abs((imgDimension.height + space) * Math.cos(angle));
      }
    }
  }
  if (proP.length > 0 && proP[pInd].length === 0) proP.pop();
  // Panel Calculations
  calculatedRotateStructure({
    newImages,
    proP,
    imgDimension,
    dispatch,
    quantityInfo,
    roofInfo,
    roofDetail,
    azimuth,
  });
};

export const calculatedRotateStructure = ({
  newImages,
  proP,
  imgDimension,
  dispatch,
  quantityInfo,
  roofInfo,
  roofDetail,
  azimuth,
}) => {
  const myObject = {
    images: newImages,
    structureType: "Single",
    totalKilowatt: 0,
    totalStructure: "--",
    pvModule: 0,
    endClamp: 0,
    midClamp: 0,
    price: 0,
    mountingStructure: "Customized Structure",
    railLength: 0,
    walkWayLength: 0,
    beam: 0,
    polls: 0,
    rails: 0,
    azimuth: azimuth,
    rowDistance: roofDetail.rowDistance,
    multipleStructure: [],
  };

  let panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  let panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );

  // Need to update
  let noOfPvModule = Object.values(newImages).reduce(
    (sum, value) => sum + value.rowFrame * value.colFrame,
    0
  );

  const totalKilowatt = (noOfPvModule * (panel.pMax / 1000)).toFixed(1);

  myObject.totalKilowatt = totalKilowatt;
  myObject.pvModule = noOfPvModule;
  myObject.totalKilowatt = totalKilowatt;

  proP = { ...proP };
  dispatch(
    updateRoofDetails({
      index: quantityInfo.roofNo,
      fields: {
        ...myObject,
        proP: proP,
      },
    })
  );
  proP = Object.values(proP);

  const value = { ...roofDetail, ...myObject };
  generationLosses(value, quantityInfo, dispatch);
};

export const addCustomizeImage = ({
  dispatch,
  roofInfo,
  currentPos,
  quantityInfo,
  designParameter,
}) => {
  const roofData = quantityInfo.roofData;
  const roofIndex = quantityInfo.roofNo;
  const roofDetail = roofData.length > 0 ? roofData[roofIndex] : [];
  const images = roofDetail?.images || [];

  let angleDegrees = 0;
  if (images.length > 0) {
    angleDegrees = images[0].angleDegree;
  }

  const imgDimension = handleImageDimension({
    roofInfo,
    roofDetail,
    designParameter,
  });

  const imagex = images.filter(
    (item) =>
      currentPos.x - imgDimension.width - 5 <= item.x &&
      currentPos.x + 5 >= item.x &&
      currentPos.y - 5 <= item.y &&
      currentPos.y + 5 >= item.y &&
      item.angleDegree === 0
  );
  let yValue = currentPos.y;
  let xValue = currentPos.x;
  if (imagex.length > 0) {
    const val = imagex[imagex.length - 1];
    yValue = val.y + val.height - imgDimension.height;
  }
  if (imagex.length > 0) {
    xValue =
      imagex[imagex.length - 1].x +
      // imgDimension.width +
      imagex[imagex.length - 1].width +
      imgDimension.frameSpacing;
  }
  console.log(imagex[0]);
  const imageId = Number(xValue * yValue);

  const newImage = {
    id: imageId,
    x: xValue,
    y: yValue,
    width: imgDimension.width,
    height: imgDimension.height,
    gap: imgDimension.gap,
    angleDegree: angleDegrees,
    rowFrame: imgDimension.rowFrame,
    colFrame: imgDimension.colFrame,
    moduleSpacing: imgDimension.moduleSpacing,
  };
  const newImages = [...images, newImage];
  calculatedCustomStructure({
    newImages,
    dispatch,
    roofDetail,
    quantityInfo,
    imgDimension,
  });
};
